import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { User } from "../../common/external-sources/Users";
import { EntryTypes } from "../../common/fields";
import { Modes } from "../../common/fields/mode";
import { readStoredText, writeStoredText } from "../../common/fields/stored";

export const materialNumber: FieldSchema = {
  grid: {
    displayed: true,
    order: 3,
    defaultVisible: true,
    filterBlank: true,
  },
  name: "materialNumber",
  // Declared for both inbound directions: the rule belongs to the attribute, not to
  // whether the record arrived from AppSync or from a DynamoDB read.
  dataTransform: {
    fromGraphql: { getter: ({ materialNumber }) => readStoredText(materialNumber) },
    fromDb: { getter: ({ materialNumber }) => readStoredText(materialNumber) },
    // Back out as the placeholder: this column is one an index is keyed on, or
    // one the resolvers keep a placeholder in for a consumer's index.
    toDb: { getter: ({ materialNumber }) => writeStoredText(materialNumber) },
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Material number",
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Bi-Directional","P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
};
